module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAADNX8xBAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAOFJREFUOI3tzzFKxEAUh/HvvZ1O3EJJYbmFrQhbWFl5BO+RyeQkIZA6N7By1cJriFruAUSrNGHm2ShIRHYT23zlf3g/GGFQnudXqnoDLIdvfxSBVn4uIYRLM7sHDoC1iHzsUlJKpyKycd+D9/7CzDZfCH3fb5umedsFlWXpUkoLB1AUxTlwBxzu+Z1fqff+DHgEjqYiACoiD8DxYH/Osux9DOSAE+A6pbQFUFXruu6lqqo0FsLMnuq6fh1zOEz/czxDMzRDe+eApKqrEEI/BYgxrkQkOhFpzewWWEyBRCQC7SeyZkV44OHZCQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/story/images/noun_Project_3323792.png
// module id = 4/zM
// module chunks = 1